import { browsers } from './browsers';
import { utils } from './utils';
const corrections = {
  addClass : function (config) {
    var el = document.querySelector(config.target);
    var browser = browsers.whichBrowser();
    if (browser[config.browser]) {
      var newClass = 'config-' + config.className;
      el.classList.add(newClass);
    } else {
      utils.Log('No Worries');
    }
  }
};
export {corrections};
